var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTeacherGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2828 67.9296L61.0081 72.5073L72.0001 86.4133L47.7508 108.475C44.1065 111.821 38.6696 112.494 34.2964 110.109L18.8919 101.762C11.4851 97.7421 7.74231 89.4138 9.7319 81.3741C11.2093 75.3923 15.6613 70.5069 21.5906 68.4105L29.4505 65.66L42.629 75.5077L56.6547 64.6406L65.2828 67.9296Z",
    fill: "#7BCCB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5569 63.1279L36.9019 73.7154L22.9873 63.3759",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7785 85.8154H117.949V94.8904H68.9365",
    stroke: "#7BCCB7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1767 32.8777C19.1767 32.8777 13.3207 10.3657 33.616 8.75203C43.7035 7.94522 46.6515 13.8881 47.4938 17.9222",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9603 34.3898C54.9603 34.3898 55.7931 24.2955 53.9853 19.2676C52.1978 14.2591 45.9619 13.2148 45.9619 13.2148",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9619 52.54V58.8498C45.9619 60.7117 46.9847 62.3667 48.4836 62.9666L56.6834 66.1525",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1501 31.7367C27.5082 31.7367 24.1293 29.8862 22.106 26.8281L19.1115 33.6845H17.6345C16.1979 33.6845 15.1053 34.9506 15.3684 36.3141L16.2586 40.8916C16.5419 42.3719 17.8773 43.4432 19.4352 43.4432H21.0538L21.1145 43.7159C21.8227 51.2346 28.3984 57.0781 36.0263 57.0781C43.6541 57.0781 50.1894 51.3904 50.8975 43.7159L50.9582 43.4432H52.5769C54.1348 43.4432 55.4702 42.3719 55.7535 40.8916L56.6437 36.3141C56.9067 34.9506 55.8344 33.6845 54.3776 33.6845H52.9006L49.9061 26.8281C47.8828 29.9057 44.5039 31.7367 40.862 31.7367H31.1501Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6836 8.67773H111.823V85.8152",
    stroke: "#7BCCB7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7134 91.6468L58.0706 72.6086L67.4053 83.9327L41.8589 106.999C38.1924 110.305 32.7224 110.97 28.3227 108.614L12.8244 100.368C5.37252 96.3968 1.60696 88.1698 3.60865 80.2277C5.09506 74.3186 9.5741 69.4926 15.5396 67.4216L24.3391 64.3625C26.4002 63.6405 27.7876 61.7595 27.7876 59.6505V55.5654",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69.1773L84.2532 35.9023",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7471 73.715L60.3347 73.3071C62.352 71.9115 63.8602 69.7859 64.5653 67.2953L64.624 67.0591C65.3879 64.3538 67.3857 62.2926 69.8928 61.627L75.0635 60.1025",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4053 81.2777L68.7825 80.4072L69.3564 80.4451C71.6901 80.6343 73.9856 79.7449 75.5733 78.0417L80.0303 73.2538C81.4267 71.7587 81.5797 69.4878 80.3937 67.8225L75.975 61.6152",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeacherGreen);
export default __webpack_public_path__ + "static/media/icon-teacher-green.0ccadc6f2ab5fe0e1696679303cc102d.svg";
export { ForwardRef as ReactComponent };